import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useCurrentUserRole = () => {
  return useQuery({
    queryKey: ["current_user_role"],
    queryFn: async () => {
      const { data: { session } } = await supabase.auth.getSession();
      
      if (!session) return null;
      
      const { data: userRoles, error } = await supabase
        .from("user_roles")
        .select(`
          role:roles!fk_user_roles_role(name)
        `)
        .eq("user_id", session.user.id)
        .limit(1)
        .single();
        
      if (error || !userRoles?.role) return null;
      
      return userRoles.role.name;
    },
  });
};